import React, { useEffect, useState } from 'react'
import DashboardNav from '../../components/Nav/DashboardNav'
import Footer from '../../components/Footer/Footer'
import submit_pic from '../assets/submit.jpg'
import RateCountrySelector from '../Rate/RateCountrySelector'
import RateCategorySelector from '../Rate/RateCategorySelector'
import RateEventSelector from '../Rate/RateEventSelector'
import { jwtDecode } from 'jwt-decode'
import baseUrl from '../../components/baseUrl'
import axios from 'axios'
import { useNavigate, useLocation } from 'react-router-dom'
import SuccessModal from './SuccessModal'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import communitydrivenicon from '../assets/communitydriven.svg'
import verifiedreviewsicon from '../assets/verifiedreviews.svg'
import qualityratingsicon from '../assets/qualityratings.svg'
import deleteicon from '../assets/deleteicon.svg'
import uploadfileicon from '../assets/uploadfileicon.svg'
import errorIcon from '../../components/assets/error.svg'

const Submit = ({ reviewData, vendorCountryData, categoryData, eventData }) => {
  const [country, setCountry] = useState('')
  const [category, setCategory] = useState('')
  const [vendor, setVendor] = useState('')
  const [email, setEmail] = useState('')
  const [vendorInstagram, setVendorInstagram] = useState('')
  const [eventId, setEventId] = useState(null)
  const [categoryId, setCategoryId] = useState(null)
  const [countryId, setCountryId] = useState(null)
  const [countryError, setCountryError] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [eventError, setEventError] = useState('');
  const [serviceDescriptionError, setserviceDescriptionError] = useState('');
  const [vendorError, setVendorError] = useState('');
  const [vendorEmail, setVendorEmail] = useState('')
  const [vendorEmailError, setVendorEmailError] = useState('');
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [listingType, setListingType] = useState('myself'); // default
  const [serviceDescription, setServiceDescription] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [city, setCity] = useState('');
  const [website, setWebsite] = useState('');
  const [personalIdFile, setPersonalIdFile] = useState(null);
  const [businessCertFile, setBusinessCertFile] = useState(null);
  const [personalIdFileError, setPersonalIdFileError] = useState("");
  const [businessCertFileError, setBusinessCertFileError] = useState("");

  // If listing is on behalf of someone, service description is not required — clear any prior error
  useEffect(() => {
    if (listingType !== 'myself') {
      setserviceDescriptionError('');
    }
  }, [listingType]);

  const location = useLocation();
const claimMode = location.state?.mode === "claim";
const claimedVendor = location.state?.vendorData;

useEffect(() => {
  if (!claimMode || !claimedVendor) return;

  setVendor(claimedVendor.vendor_name);

  if (claimedVendor.vendor_country) {
    setCountry(claimedVendor.vendor_country.vendor_country_name);
    setCountryId(claimedVendor.vendor_country.vendor_country_id);
  }

  if (claimedVendor.category) {
    setCategory(claimedVendor.category.category_name);
    setCategoryId(claimedVendor.category.category_id);
  }
  setListingType("myself");
}, [claimMode, claimedVendor]);


  const [vendorInstagramError, setvendorInstagramError] = useState('');
  const [loading, setLoading] = useState(false); // Track loading state
  const [showModal, setShowModal] = useState(false);
  const [accessToken, setAccessToken] = useState()

  const [filteredCountries, setFilteredCountries] = useState(vendorCountryData);
  const [filteredCategories, setFilteredCategories] = useState(categoryData);
  const [filteredEvents, setFilteredEvents] = useState(eventData);
  const [step, setStep] = useState(1);

  const handleStepClick = (targetStep) => {
    if (targetStep === 1) {
      setStep(1);
      return;
    }

    if (targetStep === 2) {
      const isServiceInvalid = listingType === 'myself' && serviceDescription.trim() === '';

      // VALIDATION before going to step 2
      if (!vendor || !country || !category || isServiceInvalid) {
        setVendorError(!vendor ? 'Vendor is required' : '');
        setCountryError(!country ? 'Country is required' : '');
        setCategoryError(!category ? 'Category is required' : '');

        // Only set service description error if required
        setserviceDescriptionError(isServiceInvalid ? 'Service description is required' : '');

        return;
      }

      setStep(2);
    }
  };


  // Function to handle category selection and automatically filter vendors and countries
  const handleCategorySelect = (selectedCategory, category_id) => {
    setCategory(selectedCategory);
    setCategoryId(category_id)
    // Clear error once a category is selected
    setCategoryError('');
  };

  // Function to handle country selection and automatically filter vendors and categories
  const handleCountrySelect = (selectedCountry, vendor_country_id) => {
    setCountry(selectedCountry);
    setCountryId(vendor_country_id);
    // Clear error once a country is selected
    setCountryError('');

  };


  // Decode the data 
  function decodeData(data) {
    return atob(data); // Base64 encoding
  }
  useEffect(() => {
    const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
    // Decode the JWT token
    const decodedToken = storeToken ? decodeData(storeToken) : null;
    const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
    if (userInfo) {
      setAccessToken(decodedToken)
      setUser(userInfo?.user)
    }
    else {
      navigate('/');
    }
  }, [navigate])

  useEffect(() => {
    setFilteredCountries(vendorCountryData)
    setFilteredEvents(eventData)
    setFilteredCategories(categoryData)
    // setFilteredVendors(vendorData)
  }, [vendorCountryData, categoryData])


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling behavior
    });
  };

  const handleSubmit = async (event) => {

    // Validate required fields
    if (!vendor) {
      setVendorError('Vendor is required');
      scrollToTop();
    } else {
      setVendorError('');
    }

    if (!category) {
      setCategoryError('Category is required');
      scrollToTop();
    } else {
      setCategoryError('');
    }

    if (!country) {
      setCountryError('Country is required');
      scrollToTop();
    } else {
      setCountryError('');
    }


    if (!vendorInstagram) {
      setvendorInstagramError('Vendor Instagram name is required');
      scrollToTop();
    } else {
      setvendorInstagramError('');
    }

    // Email validation only when listing type is 'myself'
    if (listingType === 'myself' && !vendorEmail) {
      setVendorEmailError('Email is required');
      scrollToTop();
    } else {
      setVendorEmailError('');
    }

    if (listingType === 'myself' && serviceDescription.trim() === '') {
      setserviceDescriptionError("Service description is required");
      return; // stop form submission
    } else {
      setserviceDescriptionError("");
    }


    if (listingType === 'myself') {


      let hasError = false;

      if (!personalIdFile) {
        setPersonalIdFileError("Personal ID is required");
        hasError = true;
      } else {
        setPersonalIdFileError("");
      }

      if (!businessCertFile) {
        setBusinessCertFileError("Business Certificate is required");
        hasError = true;
      } else {
        setBusinessCertFileError("");
      }

      if (hasError) {
        window.scrollTo({ top: 200, behavior: "smooth" });
        return;
      }
    }



    // Proceed only if all validations pass
    if (vendor && category && country && vendorInstagram) {
      // All validations passed — send FormData
      const formData = new FormData();
      // Use vendor-provided email when listing for myself, else fallback to current user email
      formData.append("email", listingType === 'myself'
        ? ` ${user?.email}, Vendor Email: ${vendorEmail}`
        : user?.email
      );
      formData.append("first_name", user?.first_name);
      formData.append("last_name", user?.last_name);
      formData.append("vendor", vendor);
      formData.append("country_id", countryId);
      formData.append("country", country);
      formData.append("category_id", categoryId);
      formData.append("category", category);
      formData.append("vendorInstagram", vendorInstagram);
      formData.append("city", city);
      formData.append("website", website);
      formData.append("listingType", listingType);
      formData.append("serviceDescription", serviceDescription);
      formData.append("whatsappNumber", whatsappNumber);

      // Append files if they exist
      if (personalIdFile) formData.append("personalIdFile", personalIdFile);
      if (businessCertFile) formData.append("businessCertFile", businessCertFile);

      try {
        const response = await axios.post(`${baseUrl}/submitForm`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(accessToken)}`,
          },
        });

        if (response.data.success) {
          // Reset all fields on successful submission
          resetFields();
          setShowModal(true); // Show success modal
        } else {
          alert("Error: " + response.data.error);
        }
      } catch (error) {
        alert("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };
  const resetFields = () => {
    setVendor('');
    setCategory(''); // Reset to default empty state
    setCountry('');
    setVendorInstagram('');
    setServiceDescription('');
    setCategoryId(null);
    setCountryId(null);
    setVendorEmail('');
    setWhatsappNumber('');
    setCity('');
    setWebsite('');
    setPersonalIdFile(null);
    setBusinessCertFile(null);
    setFilteredCountries(vendorCountryData); // Reset to full list
    setFilteredCategories(categoryData); // Reset to full list
    setStep(1);
  };


  const handleInstagramChange = (event) => {
    const val = event.target.value;
    setVendorInstagram(val);
    if (val && vendorInstagramError) {
      setvendorInstagramError('');
    }
  };

  const handleVendorNameChange = (event) => {
    const val = event.target.value;
    setVendor(val);
    if (val && vendorError) {
      setVendorError('');
    }
  };
  const handleVendorEmailChange = (event) => {
    const val = event.target.value;
    setVendorEmail(val);
    if (val && vendorEmailError) {
      setVendorEmailError('');
    }
  };

  const handleServiceDescriptionChange = (event) => {
    const val = event.target.value;

    setServiceDescription(val);

    // Validation: required only when listingType is "myself"
    if (listingType === 'myself') {
      if (val.trim() === '') {
        setserviceDescriptionError('Service description is required');
      } else {
        setserviceDescriptionError('');
      }
    } else {
      // Optional when listingType is NOT "myself"
      setserviceDescriptionError('');
    }
  };

  return (
    <div>
      {showModal && (
        <SuccessModal setShowModal={setShowModal} resetFields={resetFields} claimMode={claimMode} />
      )}

      <DashboardNav />

      <div className=' login flex flex-row  items-center justify-between gap-[0]  pt-[95px] sm:pt-[112px] md:pt-[16vh] mg:pt-[14vh]   '>
        <div className="flex-1 flex justify-center items-center self-center">

          <div className=" bg-white px-[22px] pt-[0px] pb-[32px] md:px-[32px] w-full relative overflow-auto lg:px-[32px] xl:px-[64px]">

            <div className="w-full lg:flex-1 flex flex-col justify-center items-center text-center gap-[5px] lg:gap-[15px]  rounded-t-[30px] "

            >          <div className="w-full lg:flex-1 flex flex-col justify-center items-center text-center gap-[5px] lg:gap-[15px] rounded-t-[30px] "
              style={{
                background: "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
                borderTopLeftRadius: "30px",
                borderTopRightRadius: "30px",
                paddingTop: "20px",
              }}
            >
                <p className='flex flex-col text-black font-black  text-[24px] pt-[31px]  lg:text-[32px] md:leading-[30.2px]] xl:text-[42px] xl:leading-[40.5px]'>{claimMode ? "Claim this business" : "List your business"}</p>
                <p className=' font-medium md:w-[395px] mb-[28px] md:mb-[50px] lg:mt-[5px] lg:mb-[37px] w-[251px] xl:mb-[45px] xl:w-full text-black text-[16px] '>{claimMode ? "Take control of your business profile and reach more customers": "Join our community of vendors by submitting a vendor"} </p>

                <div className="flex w-[315px] md:w-[355px] lg:w-[395px] h-[80px] mb-[66px] md:mb-[58px] lg:mb-[67px] xl:mb-[85px] flex-row justify-between gap-[20px]">

                  {/* Item 1 */}
                  <div className="flex flex-col items-center text-center gap-[10px]">
                    <img
                      src={communitydrivenicon}
                      alt="Community Driven"
                      className="w-[34px] h-[34px]"
                    />
                    <p className="text-[16px] font-medium">Community driven</p>
                  </div>

                  {/* Item 2 */}
                  <div className="flex flex-col items-center text-center gap-[8px]">
                    <img
                      src={verifiedreviewsicon}
                      alt="Verified Reviews"
                      className="w-[34px] h-[34px]"
                    />
                    <p className="text-[16px] font-medium">Verified reviews</p>
                  </div>

                  {/* Item 3 */}
                  <div className="flex flex-col items-center text-center gap-[8px]">
                    <img
                      src={qualityratingsicon}
                      alt="Quality Ratings"
                      className="w-[34px] h-[34px]"
                    />
                    <p className="text-[16px] font-medium">Quality ratings</p>
                  </div>

                </div>
              </div>

              <div className="flex items-center justify-center w-[256px] lg:w-[298px] h-[54px] ">
                {/* STEP 1 */}
                <div className="flex items-center cursor-pointer"
                  onClick={() => handleStepClick(1)}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-full 
      ${step === 1 ? "bg-[#0079FF] text-white" : "bg-[#F1F1F1] text-black text-[14px]  border"} 
      font-semibold`}>
                    1
                  </div>
                </div>
                {/* LINE */}
                <div className="flex-1 h-[1px] bg-[#e5e5e5]"></div>
                {/* STEP 2 */}
                <div className="flex items-center cursor-pointer"
                  onClick={() => handleStepClick(2)}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-full 
      ${step === 2 ? "bg-[#0079FF] text-white" : "bg-[#F1F1F1] text-black border"} 
      font-semibold`}> 2
                  </div>
                </div>

              </div>

              {/* COMPANY INFORMATION */}
              {step === 1 && (
                <div className=" flex mt-[42px] lg:mt-[45px] xl:mt-[50px] w-full md:w-[327px] lg:w-[555px] xl:w-[560px] flex-col gap-4 bg-white rounded-[20px]">
                  <h2 className="text-4 font-black items text-black items-start left-6 ">{listingType === 'myself' ? "Company  Details" : "Vendor Details"}</h2>
                  {claimMode ? null :
                  <div className="w-full border h-[131px] lg:h-[122px] xl:h-[162px] border-[#c1c1c180] rounded-[20px] pl-5 py-[14px] md:pl-[24px] md:py-[10px] flex flex-col gap-[10px]">
            
                    {/* OPTION 1 */}
                    <label className="flex items-start gap-1.5 cursor-pointer">
                      <input
                        type="radio"
                        name="listingType"
                        value="myself"
                        checked={listingType === "myself"}
                        onChange={() => setListingType("myself")}
                        className="w-5 h-5 accent-ravblue"
                      />

                      <div className="flex flex-col items-start">
                        <span className="font-bold text-[16px] text-black"> Myself </span>
                        <span className="text-[14px] font-medium text-[#aaaaaa] -mt-[2px]"> I'm listing my own business </span>
                      </div>
                    </label>

                    {/* OPTION 2 */}
                    <label className="flex items-start gap-1.5 cursor-pointer">
                      <input
                        type="radio"
                        name="listingType"
                        value="behalfofsomeone"
                        checked={listingType === "behalfofsomeone"}
                        onChange={() => setListingType("behalfofsomeone")}
                        className="w-5 h-5 accent-ravblue"
                      />
                      <div className="flex flex-col items-start">
                        <span className="font-bold text-[16px] text-black">
                          On Behalf of someone
                        </span>
                        <span className="text-[14px] text-[#aaaaaa] font-medium -mt-[2px]">
                          I'm listing on behalf of another vendor
                        </span>
                      </div>
                    </label>

                  </div>
}

                  <input type="text" name="vendor_name" id="vendor_name" placeholder='Enter company name' className={`w-full h-[45px] lg:h-[50px] rounded-[80px] bg-[white] outline-none border-[#C1C1C180] border-[1px] px-[18px] md:px-[20px] lg:px-[29px] flex items-center ${claimMode ? "bg-white pointer-events-none cursor-not-allowed" : "bg-white"} ${vendorError ? 'placeholder:text-[#EB0728] border border-[#EB0728]' : 'placeholder:text-[#aaaaaa]'}  text-base lg:text-sm font-medium `} value={vendor} onChange={handleVendorNameChange} />
                  <div className=' w-full md:w-[327px] lg:w-[555px] xl:w-[560px] gap-[10px] flex flex-col md:gap-[15px]' >
                    <RateCountrySelector placeholder="Select a country" countryError={countryError} setCountryError={setCountryError} vendorCountryData={vendorCountryData} handleCountrySelect={handleCountrySelect} device="small" icon={false} customstyle={true} selectedCountry={country} />
                    <RateCategorySelector placeholder="Select a category" categoryError={categoryError} setCategoryError={setCategoryError} categoryData={categoryData} handleCategorySelect={handleCategorySelect} device="small" icon={false} customstyle={true} selectedCategory={category} />
                  </div>

                  <textarea
                    placeholder="Describe the services this vendor provides"
                    className={`w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[165px] outline-none  rounded-[20px] bg-white disabled:text-ravash px-[18px] md:px-[20px] lg:px-[29px] py-[18px]  text-base lg:text-sm font-medium resize-none ${serviceDescriptionError ? 'placeholder:text-[#EB0728] border border-[#EB0728]' : 'placeholder:text-[#aaaaaa] border border-[#C1C1C180]'}  text-base lg:text-sm font-medium `}
                    value={serviceDescription}
                    onChange={handleServiceDescriptionChange}
                  >
                  </textarea>
                  <button onClick={() => handleStepClick(2)} className="mt-[11px] w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[45px] rounded-[80px] bg-[#0079FF] flex items-center justify-center text-white font-bold"> Continue </button>
                </div>
              )}


              {/* CONTACT INFORMATION */}
              {step === 2 && (
                <div className="flex w-full mt-[42px] lg:mt-[45px] xl:mt-[50px] md:w-[327px] lg:w-[555px] xl:w-[560px] flex-col gap-4 bg-white rounded-[20px]">
                  <h2 className="text-4 font-black items-start text-black left-6 ">{listingType === 'myself' ? "Company Contact Details" : "Vendor Contact Details"}</h2>
                  <input
                    value={listingType === 'myself' ? vendorEmail : ''}
                    onChange={handleVendorEmailChange}
                    type="email"
                    name="email"
                    id="email"
                    placeholder='Enter company email'
                    className={`${listingType === 'myself' ? '' : 'hidden'} w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[45px] lg:h-[50px] border-[1px] rounded-[80px] outline-none px-[18px] md:px-[20px] lg:px-[29px] flex items-center  text-base lg:text-sm font-medium ${vendorEmailError ? 'placeholder:text-[#EB0728] border border-[#EB0728]' : 'placeholder:text-[#aaaaaa] border-[#C1C1C180] '}`}
                  />
                  <input
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter company whatsapp number"
                    className='w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[45px] lg:h-[50px] border-[#C1C1C180] outline-none border-[1px] rounded-[80px] bg-[white] disabled:text-ravash px-[18px] md:px-[20px] lg:px-[29px] flex items-center placeholder:text-[#aaaaaa] text-base lg:text-sm font-medium'
                    value={whatsappNumber}
                    onChange={(e) => {
                      const digitsOnly = e.target.value.replace(/\D/g, '');
                      setWhatsappNumber(digitsOnly);
                    }}
                  />

                  <input
                    type="text"
                    name="vendor_instagram_name"
                    id="vendor_instagram_name"
                    placeholder="Enter company instagram handle"
                    className={`w-full md:w-[327px] outline-none lg:w-[555px] xl:w-[560px] h-[45px] lg:h-[50px] rounded-[80px] border-[#C1C1C180] border-[1px] bg-[white] px-[18px] md:px-[20px] lg:px-[29px] flex items-center ${vendorInstagramError ? 'placeholder:text-[#EB0728] border border-[#EB0728]' : 'placeholder:text-[#aaaaaa]'}  text-base lg:text-sm font-medium `}
                    value={vendorInstagram}
                    onChange={handleInstagramChange} // Capture input change
                  />

                  <input type="text" placeholder="Enter city" className='w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[45px] lg:h-[50px] border-[#C1C1C180] outline-none border-[1px] rounded-[80px] bg-[white] disabled:text-ravash px-[18px] md:px-[20px] lg:px-[29px] flex items-center placeholder:text-[#aaaaaa] text-base lg:text-sm font-medium'
                    value={city}
                    onChange={(e) => setCity(e.target.value)} />
                  <input type="text" placeholder="Enter company website www.company.com" className='w-full md:w-[327px] lg:w-[555px] xl:w-[560px] h-[45px] lg:h-[50px] border-[#C1C1C180] outline-none border-[1px] rounded-[80px] bg-[white] disabled:text-ravash px-[18px] md:px-[20px] lg:px-[29px] flex items-center placeholder:text-[#aaaaaa] text-base lg:text-sm font-medium'
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                  {(businessCertFileError || personalIdFileError) && (
                    <p className="mt-5 flex items-center justify-center text-[#EB0728] bg-[#FFDFE4] rounded-full font-medium py-1.5 text-xs text-center gap-1">
                      <img src={errorIcon} alt="" className="w-3.5 h-3.5" />
                      Please upload a file to complete this step
                    </p>
                  )}

                  {listingType === 'myself' && (

                    <div className="grid grid-cols-1 lg:grid-cols-2 justify-between ">
                      {/* UPLOAD PERSONAL ID */}
                      <div className="flex flex-col gap-[10px]">
                        <label className="text-start mt-2 text-base font-medium text-[#aaaaaa]">
                          Upload your Personal ID
                        </label>

                        {/* Upload Box */}
                        {!personalIdFile && (
                          <label className="w-full bg-[#E6F7FF]/50 lg:w-[270px] h-[165px] border-[1px] border-dashed border-[#C1C1C180] rounded-[20px] flex flex-col items-center justify-center cursor-pointer">
                            <input
                              type="file"
                              accept=".pdf, .jpg, .jpeg, .png"
                              className="hidden"
                              onChange={(e) => {
                                setPersonalIdFileError("");
                                setPersonalIdFile(e.target.files[0]);
                              }}
                            />
                            <p className="text-[#aaaaaa] text-[12px]">
                              Drop files or <span className="text-ravblue font-black">Choose file</span> to upload
                            </p>
                            <p className="text-xs text-[#aaaaaa]">PDF, JPG, PNG</p>
                          </label>
                        )}



                        {/* Uploaded File Display */}
                        {personalIdFile && (
                          <div className="mt-2  lg:mt-0 px-4 py-2 bg-[#E6F7FF50] gap-1 border border-[#C1C1C180] w-full lg:w-[270px] rounded-[10px] flex justify-between items-center">
                            <div className="flex items-center gap-1">
                              <img src={uploadfileicon} alt="uploaded" className="h-6 w-6" />
                              <div className="flex flex-col items-start">
                                <p className="text-base font-bold text-black text-start">{personalIdFile.name}</p>
                                <p className="text-xs text-[#009428] font-medium">Completed</p>
                              </div>
                            </div>

                            <button
                              onClick={() => {
                                setPersonalIdFile(null);
                                setPersonalIdFileError("Personal ID is required");
                              }}
                         className="w-5 h-5 flex items-center justify-center shrink-0"   >
                              <img src={deleteicon} alt="remove" className="h-5 w-5 cursor-pointe shrink-0" />
                            </button>
                          </div>
                        )}
                      </div>

                      {/* UPLOAD BUSINESS CERTIFICATE */}
                      <div className="flex flex-col gap-[10px]">
                        <label className="text-start text-base mt-5 lg:mt-2 font-medium text-[#aaaaaa]"> Upload your Business Certificate </label>
                        {!businessCertFile && (
                          <label
                            className="bg-[#E6F7FF]/50 w-full lg:w-[270px] h-[165px] border-[1px] border-dashed border-[#C1C1C180] rounded-[20px] flex flex-col items-center justify-center cursor-pointer"
                          >
                            <input
                              type="file"
                              accept=".pdf, .jpg, .jpeg, .png"
                              className="hidden"
                              onChange={(e) => { setBusinessCertFileError(''); setBusinessCertFile(e.target.files[0]) }}
                            />

                            <p className="text-[#aaaaaa] text-[12px]">Drop files or <span className="text-ravblue font-black">Choose file</span> to upload</p> <p className="text-xs text-[#aaaaaa]">PDF, JPG or PNG</p>
                          </label>
                        )}


                        {businessCertFile && (
                          <div className="px-4 py-2 bg-[#E6F7FF50] gap-1 border lg:w-[270px] border-[#C1C1C180] rounded-[10px] w-full flex justify-between items-center">
                            {/* Left: icon + text */}
                            <div className="flex items-center gap-1 ">
                              <img src={uploadfileicon} alt="uploaded file" className="h-5 w-5 shrink-0" />
                              <div className="flex flex-col items-start">
                                <p className="text-start text-base font-bold text-black">{businessCertFile.name}</p>
                                <p className="text-xs text-[#009428] font-medium">Completed</p>
                              </div>
                            </div>
                            {/* Right: remove button */}
                            <button onClick={() => { setBusinessCertFile(null); setBusinessCertFileError("Business Certificate is required"); }} className="w-5 h-5 flex items-center justify-center shrink-0">
                              <img src={deleteicon} alt="remove file" className="h-5 w-5 cursor-pointer" />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="flex flex-row gap-[11px] mt-[11px] lg:px-[52px] xl:px-[55px] ">
                    <button onClick={() => setStep(1)} className="flex-1 w-full h-[44px] lg:w-[220px] rounded-[80px] border border-black bg-[white] flex items-center justify-center text-black font-bold"> Back </button>
                    <button onClick={handleSubmit} type="submit" className="flex-1 w-full h-[44px] lg:w-[220px] rounded-[80px] bg-[#0079FF] flex items-center justify-center text-white font-bold"> Submit </button>
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
      <div className='hidden lg:block'>
        <Footer />
      </div>
    </div>
  )
}

export default Submit
